import PropTypes from 'prop-types';

const BookPopover = (props) => (
  <div className="book-popover">
    <i className="icon-close" onClick={props.closeup} />
    {props.children}
  </div>
);

BookPopover.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  closeup: PropTypes.func
};

BookPopover.defaultProps = {
  closeup: () => {}
};

export default BookPopover;
